function getOwnedDomains() {
  const configuredDomains = window.themeSettings?.owned_internal_domains || window.location.hostname;
  return String(configuredDomains)
    .split(/[\s,]+/)
    .map((domain) => domain.trim().toLowerCase().replace(/^https?:\/\//, '').replace(/^\/\//, '').split('/')[0])
    .filter(Boolean);
}

export function localizeUrl(url) {
  if (!url) return url;
  if (/^(https?:)?\/\//.test(url) || url.startsWith('#')) return url;

  const root = window.Shopify?.routes?.root || '/';
  if (root === '/' || url.startsWith(root)) return url;

  const cleanRoot = root.endsWith('/') ? root : `${root}/`;
  const cleanUrl = url.startsWith('/') ? url.slice(1) : url;

  return `${cleanRoot}${cleanUrl}`;
}

export function toRelativePath(url) {
  if (!url) return url;
  if (!/^(https?:)?\/\//.test(url)) return url;

  try {
    const parsed = new URL(url, window.location.origin);
    const hostname = parsed.hostname.toLowerCase();
    const currentHostname = window.location.hostname.toLowerCase();
    const isOwnedDomain = getOwnedDomains().some(
      (domain) => hostname === domain || hostname.endsWith(`.${domain}`)
    );
    const isCurrentDomain = hostname === currentHostname;

    if (isOwnedDomain || isCurrentDomain) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    // Relative URLs are already safe to use on the current regional host.
  }

  return url;
}
